import table from '@/lib/countries.json';

/*
 * Country codes for the maps. countries.json is generated by
 * backend/scripts/build_country_table.py so the app and the API agree on names and regions.
 */

const BY_A2 = Object.fromEntries(table.countries.map((c) => [c.a2, c]));
const NUM_TO_A2 = Object.fromEntries(table.countries.map((c) => [c.num, c.a2]));

export const countryName = (a2) => BY_A2[a2]?.name || a2 || '';
export const countryRegions = (a2) => BY_A2[a2]?.regions || [];
/** world-atlas features carry the ISO numeric code as a zero-padded string. */
export const a2FromNumeric = (num) => NUM_TO_A2[String(num).padStart(3, '0')] || null;

/** Up to five thresholds from 1 to max on a rounded log scale (1, 2, 5, 10, 20, 50...). */
export function niceBreaks(max) {
  const nice = (v) => {
    const e = 10 ** Math.floor(Math.log10(v));
    const f = v / e;
    return (f < 1.5 ? 1 : f < 3.5 ? 2 : f < 7.5 ? 5 : 10) * e;
  };
  const out = [1];
  const top = Math.max(2, max);
  for (let k = 1; k <= 4; k += 1) {
    const b = nice(Math.max(1, top ** (k / 5)));
    if (b > out[out.length - 1] && b <= top) out.push(b);
  }
  return out;
}

/** Index of the bin a value falls into, or -1 for no activity. */
export function binOf(value, breaks) {
  if (!(value > 0)) return -1;
  let i = 0;
  while (i + 1 < breaks.length && value >= breaks[i + 1]) i += 1;
  return i;
}

/** Fill for a bin: a mix along the theme's map ramp, so a theme switch needs no redraw. */
export function binFill(bin, count) {
  if (bin < 0) return 'var(--map-empty)';
  const pct = count <= 1 ? 100 : Math.round(18 + (82 * bin) / (count - 1));
  return `color-mix(in oklab, var(--map-hi) ${pct}%, var(--map-lo))`;
}

export const fmtCount = (n) => (n == null ? '-' : Number(n).toLocaleString('en-US'));
